import { useState } from "react";
import { Button, Dialog } from "@akin2unde/flowui-react";
import { useWarehouse } from "./WarehouseContext";
import "./Warehouse.css";
export default function WarehousePicker() {
  const { Warehouse, Warehouses, Loading, Error, SelectWarehouse, Reload } =
    useWarehouse();
  const [open, setOpen] = useState(false);
  const required = !Loading && !Error && !Warehouse && Warehouses.length > 0;
  return (
    <>
      <div className="operating-warehouse">
        <small>Operating warehouse</small>
        <Button
          variant="outline"
          disabled={Loading}
          onClick={() => setOpen(true)}
        >
          {Loading ? "Loading…" : (Warehouse?.Name ?? "Select warehouse")}
          <i className="fa-solid fa-chevron-down" />
        </Button>
      </div>
      <Dialog
        open={open || required}
        header="Which warehouse are you operating from?"
        width="480px"
        maxWidth="full"
        showCloseButton={!required}
        closeOnEscape={!required}
        closeOnOverlayClick={!required}
        onClose={() => setOpen(false)}
        body={
          <div className="warehouse-options">
            {Error && <p role="alert">{Error}</p>}
            {Loading && <p role="status">Loading warehouses…</p>}
            {!Loading && !Error && Warehouses.length === 0 && (
              <p>
                No active warehouse is assigned to your account. An
                administrator can assign warehouses on the Users screen.
              </p>
            )}
            {Warehouses.map((x) => (
              <button
                type="button"
                key={x.Code}
                className={
                  Warehouse?.Code === x.Code
                    ? "warehouse-option selected"
                    : "warehouse-option"
                }
                onClick={() => {
                  if (
                    Warehouse &&
                    Warehouse.Code !== x.Code &&
                    !window.confirm(
                      "Switch warehouse? Any open unsaved forms will be closed.",
                    )
                  )
                    return;
                  SelectWarehouse(x.Code);
                  setOpen(false);
                }}
              >
                <strong>{x.Name}</strong>
                <span>{x.Address || "Address not set"}</span>
                <small>{x.PhoneNumber}</small>
              </button>
            ))}
            <Button variant="outline" onClick={Reload}>
              Refresh warehouse access
            </Button>
          </div>
        }
      />
    </>
  );
}
